<script lang="tsx">
  export default {};
</script>

<template>
  <div class="prose">
    <slot></slot>
  </div>
</template>

<style lang="less" scoped>
  @import (reference) "@/style/main.less";

  div.prose {
    container: prose / inline-size;

    :slotted(p) {
      margin-block: calc(var(--spacing-inline) * 1.5);
      text-align: justify;
      text-wrap-style: pretty;
      hyphens: auto;
    }

    :slotted(ul), :slotted(ol), :slotted(dl) {
      margin-block: calc(var(--spacing-inline) * 1.5);
      list-style-position: inside;
      ::marker { font-weight: 700; }
    }

    :slotted(ul) { list-style-type: square; }
    :slotted(ol) { list-style-type: decimal; }

    :slotted(ul) ul, :slotted(ol) ol { padding-inline-start: calc(var(--spacing-inline) * 1.5); }

    :slotted(ul), :slotted(ol) {
      & ul { list-style-type: circle; }
      & ol { list-style-type: lower-alpha; }

      ul, ol {
        & ul { list-style-type: disc; }
        & ol { list-style-type: lower-roman; }
      }
    }

    :slotted(blockquote) {
      margin-inline-start: calc(var(--spacing-inline) * 1.5);
      border-inline-start: 3px solid var(--p-primary-800);
      background-color: color-mix(in lab, var(--p-primary-50) 80%, transparent 20%);
      padding-inline-start: var(--spacing-inline);
    }

    :slotted(table) {
      border-collapse: collapse;
      border-spacing: 0;

      & td, & th {
        padding-inline: var(--spacing-inline);

        &:first-child, &:first-child { padding-inline-start: 0; }
        &:last-child, &:last-child { padding-inline-end: 0; }
      }
    }

    :slotted(h1), :slotted(h2), :slotted(h3), :slotted(h4) {
      margin-block: var(--spacing-block-heading) 0;

      :slotted(& + *) { margin-block-start: 0; }

      @container (width < @prose-width-medium) {
        text-align: center;
      }
    }

    :slotted(h1) { margin-block-start: 0; }

    :slotted(h5), :slotted(h6) {
      display: inline;
      float: inline-start;
      text-transform: uppercase;
      margin-inline-end: calc(var(--spacing-inline) * 1.5);
    }

    :slotted(b), :slotted(strong) { font-weight: bold; }
    :slotted(i), :slotted(em), :slotted(cite) { font-style: italic; }

    :slotted(sub) {
      vertical-align: sub;
      font-size: smaller;
    }

    :slotted(sup) {
      vertical-align: super;
      font-size: smaller;
    }

    :first-child { margin-block-start: 0; }
    :last-child { margin-block-end: 0; }
  }

  // workaround for v-html being incompatible with scoped styles
  div.prose.deep {
    container: prose / inline-size;

    :deep(p) {
      margin-block: calc(var(--spacing-inline) * 1.5);
      text-align: justify;
      text-wrap-style: pretty;
      hyphens: auto;
    }

    :deep(ul), :deep(ol), :deep(dl) {
      margin-block: calc(var(--spacing-inline) * 1.5);
      list-style-position: inside;
      ::marker { font-weight: 700; }
    }

    :deep(ul) { list-style-type: square; }
    :deep(ol) { list-style-type: decimal; }

    :deep(ul) :deep(ul), :deep(ol) :deep(ol) { padding-inline-start: calc(var(--spacing-inline) * 1.5); }

    :deep(ul), :deep(ol) {
      & :deep(ul) { list-style-type: circle; }
      & :deep(ol) { list-style-type: lower-alpha; }

      ul, ol {
        & :deep(ul) { list-style-type: disc; }
        & :deep(ol) { list-style-type: lower-roman; }
      }
    }

    :deep(blockquote) {
      margin-inline-start: calc(var(--spacing-inline) * 1.5);
      border-inline-start: 3px solid var(--p-primary-800);
      background-color: color-mix(in lab, var(--p-primary-50) 60%, transparent 40%);
      padding-inline-start: var(--spacing-inline);
    }

    :deep(table) {
      border-collapse: collapse;
      border-spacing: 0;

      & :deep(td), & :deep(th) {
        padding-inline: var(--spacing-inline);

        &:first-child, &:first-child { padding-inline-start: 0; }
        &:last-child, &:last-child { padding-inline-end: 0; }
      }
    }

    :deep(h1), :deep(h2), :deep(h3), :deep(h4) {
      margin-block: var(--spacing-block-heading) 0;

      :deep(& + *) { margin-block-start: 0; }

      @container (width < @prose-width-medium) {
        text-align: center;
      }
    }

    :deep(h1) { margin-block-start: 0; }

    :deep(h5), :deep(h6) {
      display: inline;
      float: inline-start;
      text-transform: uppercase;
      margin-inline-end: calc(var(--spacing-inline) * 1.5);
    }

    :deep(b), :deep(strong) { font-weight: bold; }
    :deep(i), :deep(em), :deep(cite) { font-style: italic; }

    :deep(sub) {
      vertical-align: sub;
      font-size: smaller;
    }

    :deep(sup) {
      vertical-align: super;
      font-size: smaller;
    }

    :first-child { margin-block-start: 0; }
    :last-child { margin-block-end: 0; }
  }
</style>
